import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { destinations } from '../data/content';
const ease = [0.22, 1, 0.36, 1] as const;
export function Destinations() {
  const [active, setActive] = useState(0);
  const reduceMotion = useReducedMotion();
  const now = useMinuteClock();
  const current = destinations[active];
  return <section id="destinations" aria-labelledby="destinations-heading" className="bg-paper px-6 pb-24 pt-24 md:px-16 md:pb-32 md:pt-32" data-id="element-356" data-mp="3oqy5dh0afg20">
      <div className="mx-auto max-w-[1320px]" data-id="element-357" data-mp="3tq10a8mk05w9">
        <div className="flex flex-col gap-3 border-b border-ink pb-5 md:flex-row md:items-end md:justify-between" data-id="element-358" data-mp="2jhu56rnx44a">
          <h2 id="destinations-heading" className="font-editorial text-[34px] font-normal leading-[38px] tracking-[-0.01em] md:text-[44px] md:leading-[48px]" data-id="element-359" data-mp="7a6kgirlvv1u">
            Wherever you find yourself
          </h2>
          <p className="text-[15px] font-light text-ink/70" data-id="element-360" data-mp="3axzwcrux9pfz">A partner on the ground in every city — at any hour.</p>
        </div>

        {/* Cinematic stage */}
        <div className="relative mt-10 flex h-[640px] flex-col overflow-hidden bg-ink text-paper md:h-[78vh] md:max-h-[780px] md:min-h-[620px] lg:mt-12" data-id="element-361" data-mp="2wgbwax6znh1v">
          {destinations.map((d, i) => <motion.img key={d.city} src={d.image} alt={i === active ? d.alt : ''} aria-hidden={i !== active} className="absolute inset-0 h-full w-full object-cover" initial={false} animate={{
          opacity: i === active ? 1 : 0,
          scale: reduceMotion ? 1 : i === active ? 1 : 1.05
        }} transition={{
          duration: 1,
          ease
        }} data-id="element-362" data-mp="2mqilvzil17z7" data-mpi={i} />)}
          <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_top,rgba(0,0,0,0.78)_0%,rgba(0,0,0,0.35)_45%,rgba(0,0,0,0.1)_75%),linear-gradient(to_right,rgba(0,0,0,0.45),rgba(0,0,0,0)_60%)]" aria-hidden="true" data-id="element-363" data-mp="23sy75l9j7psb" />

          {/* Active destination */}
          <div className="relative z-[1] flex flex-1 items-end px-6 pb-10 md:px-12 md:pb-14" data-id="element-364" data-mp="1wexf7xya4y6v">
            <AnimatePresence mode="wait" initial={false} data-id="element-365" data-mp="218t7cjrv3qu4">
              <motion.div key={current.city} initial={{
              opacity: 0,
              y: reduceMotion ? 0 : 14
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: reduceMotion ? 0 : -8
            }} transition={{
              duration: 0.5,
              ease
            }} className="grid w-full grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-end" aria-live="polite" data-id="element-366" data-mp="1miud2s3fgzjx">
                <div data-id="element-367" data-mp="2661rgpwkm4y0">
                  <p className="text-[15px] font-light text-paper/80" data-id="element-368" data-mp="268nwoivzo8d2">{current.country}</p>
                  <h3 className="mt-2 font-editorial text-[64px] leading-[64px] tracking-[-0.02em] md:text-[104px] md:leading-[100px]" data-id="element-369" data-mp="2a9zql0lwbfr2">
                    {current.city}
                  </h3>
                  <p className="mt-4 max-w-[560px] text-[18px] font-light leading-[27px] text-paper/90 md:text-[21px] md:leading-[30px]" data-id="element-370" data-mp="yqn8j5njtm9f">
                    {current.focus}
                  </p>
                </div>
                <div className="flex flex-col gap-6 lg:items-end" data-id="element-371" data-mp="117emrajy2pud">
                  <dl className="flex flex-wrap gap-x-10 gap-y-3 lg:justify-end" data-id="element-372" data-mp="116wk9w6ovfe0">
                    <div data-id="element-373" data-mp="w9mwekyy7bsa">
                      <dt className="text-[13px] font-light text-paper/65" data-id="element-374" data-mp="w68sv9ejswj9">Season</dt>
                      <dd className="mt-0.5 text-[15px]" data-id="element-375" data-mp="8j94cugd5cxp">{current.availability}</dd>
                    </div>
                    <div data-id="element-376" data-mp="3lh7dm0v30mn">
                      <dt className="text-[13px] font-light text-paper/65" data-id="element-377" data-mp="i8k801khdpe7">Local time</dt>
                      <dd className="mt-0.5 text-[15px] tabular-nums" data-id="element-378" data-mp="iadijry7strh">{formatTime(now, current.timeZone)}</dd>
                    </div>
                    <div data-id="element-379" data-mp="3lwua1vjyfwf9">
                      <dt className="text-[13px] font-light text-paper/65" data-id="element-380" data-mp="3lw2o7cg5td26">Response</dt>
                      <dd className="mt-0.5 text-[15px]" data-id="element-381" data-mp="3gxrer2ts14kh">Within the hour</dd>
                    </div>
                  </dl>
                  <a href="/membership" className="group inline-flex items-center gap-3 self-start whitespace-nowrap bg-paper px-7 py-4 text-[16px] font-medium text-ink transition-opacity duration-150 hover:opacity-85 lg:self-end" data-id="element-382" data-mp="2k90c9msartew">
                    Arrange in {current.city}
                    <span aria-hidden="true" className="transition-transform duration-500 ease-luxe group-hover:translate-x-1" data-id="element-383" data-mp="32xx7ptzfkryp">
                      →
                    </span>
                  </a>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* City strip */}
          <ul className="relative z-[1] flex overflow-x-auto border-t border-paper/20 [scrollbar-width:none] md:grid md:grid-cols-7 md:overflow-visible [&::-webkit-scrollbar]:hidden" aria-label="Destinations" data-id="element-384" data-mp="3gxoizmykbu90">
            {destinations.map((d, i) => {
            const isActive = i === active;
            return <li key={d.city} className="relative min-w-[100px] shrink-0 first:ml-2 md:min-w-0 md:first:ml-0" data-id="element-385" data-mp="1f1pgvfbfcse5" data-mpi={i}>
                  <span className={`absolute inset-x-0 top-[-1px] h-px origin-left bg-paper transition-transform duration-500 ease-luxe ${isActive ? 'scale-x-100' : 'scale-x-0'}`} aria-hidden="true" data-id="element-386" data-mp="159tevt67wi4n" />
                  <button type="button" onMouseEnter={() => setActive(i)} onFocus={() => setActive(i)} onClick={() => setActive(i)} aria-pressed={isActive} className="group flex w-full flex-col items-start gap-1 px-4 py-5 text-left md:px-5" data-id="element-387" data-mp="1szx7z6ls4zhe">
                    <span className={`whitespace-nowrap text-[16px] transition-colors duration-300 ${isActive ? 'font-medium text-paper' : 'font-light text-paper/60 group-hover:text-paper/90'}`} data-id="element-388" data-mp="8jtvf3oj3z7a">
                      {d.city}
                    </span>
                    <span className={`text-[13px] font-light tabular-nums ${isActive ? 'text-paper/80' : 'text-paper/45'}`} data-id="element-389" data-mp="1rynzx7694y">
                      {formatTime(now, d.timeZone)}
                    </span>
                  </button>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}
function useMinuteClock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 30000);
    return () => window.clearInterval(id);
  }, []);
  return now;
}
function formatTime(date: Date, timeZone: string) {
  try {
    return new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone
    }).format(date);
  } catch {
    return '';
  }
}